import {
  SemanticEssentialColor,
  SemanticTextColor,
} from '@spotify-internal/encore-web';
import { ApprovalStatus } from '@hooks/useAlbumInfo/types';

export function approvalStatusColor(
  status?: ApprovalStatus,
): SemanticTextColor {
  switch (status) {
    case ApprovalStatus.APPROVED:
      return 'textPositive';
    case ApprovalStatus.DECLINED:
      return 'textNegative';
    case ApprovalStatus.PARTIALLY_APPROVED:
    case ApprovalStatus.NEEDS_APPROVAL:
      return 'textWarning';
    case ApprovalStatus.EXPIRED:
    case ApprovalStatus.NO_APPROVAL_NEEDED:
    default:
      return 'textSubdued';
  }
}

export function approvalStatusIndicatorColor(
  status?: ApprovalStatus,
): SemanticEssentialColor {
  switch (status) {
    case ApprovalStatus.APPROVED:
      return 'essentialPositive';
    case ApprovalStatus.DECLINED:
      return 'essentialNegative';
    case ApprovalStatus.PARTIALLY_APPROVED:
    case ApprovalStatus.NEEDS_APPROVAL:
      return 'essentialWarning';
    case ApprovalStatus.EXPIRED:
    case ApprovalStatus.NO_APPROVAL_NEEDED:
    default:
      return 'essentialSubdued';
  }
}
